import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";




export default function DeleteKataslip() {
  const [search, setSearch] = useState("");

  const [kataslips, setKataslips] = useState([]);
  const token = sessionStorage.getItem("token");

  /* =========================
     FETCH ALL KATASLIP
  ========================= */
  const fetchKataslip = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/delete/kataslip", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setKataslips(res.data.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch Kataslip data", "error");
    }
  };

  useEffect(() => {
    fetchKataslip();
  }, []);

  /* =========================
     DELETE FUNCTION
  ========================= */



const handleDelete = async (data) => {

  /* ======================
      BUILD TABLE DYNAMICALLY
  ====================== */

  const rows = Object.entries(data)
    .map(([key, value]) => `
      <tr>
        <td style="width:35%"><b>${key}</b></td>
        <td>${value ?? "-"}</td>
      </tr>
    `)
    .join("");

  /* ======================
      PREVIEW BEFORE DELETE
  ====================== */

  const confirm = await Swal.fire({
    title: "⚠ Kataslip Delete Confirmation",
    width: "70%",
    backdrop: true,
    allowOutsideClick: false,

    html: `
      <div style="max-height:500px;overflow:auto;text-align:left">
        <table 
          style="width:100%;border-collapse:collapse" 
          border="1"
        >
          ${rows}
        </table>

        <p style="color:red;font-weight:bold;margin-top:10px">
          This action cannot be undone!
        </p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "🗑 Yes Delete",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
  });

  if (!confirm.isConfirmed) return;

  /* ======================
        DELETE API
  ====================== */

  try {
    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    await axios.delete(
      `https://irc.zentelex.com/api/delete/kataslip/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Deleted!",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchKataslip();
  } catch (error) {
    Swal.fire("Error", "Delete failed", "error");
  }
};




  const filteredKataslips = kataslips.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.vehicleNo?.toLowerCase().includes(text) ||
      item.dateIn?.toLowerCase().includes(text) ||
      item.companyName?.toLowerCase().includes(text) ||
      item.product?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <div className="card shadow border-0">
        <div className="card-header bg-danger text-white">
          <h4 className="mb-0">Delete Kataslip</h4>
        </div>

        <div className="mb-3">
          <input
            type="text"
            className="form-control border-primary"
            placeholder="🔍 Search Kataslip / Date / Client / Commodity..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="card-body table-responsive">
          <table className="table table-hover table-bordered align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Kataslip No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Commodity</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredKataslips.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Records Found
                  </td>
                </tr>
              ) : (
                filteredKataslips.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    {/* Use correct fields */}
                    <td>{item.vehicleNo}</td>
                    <td>{item.dateIn}</td>
                    <td>{item.companyName}</td>
                    <td>{item.product}</td>

                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item)}
                      >
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
